<template>
	<div>
		<div class="dashboard-content" v-if="!approveShow && !expenseShow">
			<el-row style="margin:36px 20px 0 20px;">
				<el-col :span="6" class="state">
					<div class="state-wrap" @click="stateClick(0)">
						<div class="state-left">
							<div class="state-text">待处理</div>
							<div class="state-number">{{ Num.processing }}</div>
						</div>
						<div class="state-right">
							<img src="../../../assets/oa/state-orange.png" alt="" class="state-img">
						</div>
					</div>
				</el-col>
				<el-col :span="6" class="state">
					<div class="state-wrap" @click="stateClick(1)">
						<div class="state-left">
							<div class="state-text">已发起</div>
							<div class="state-number">{{ Num.my }}</div>
						</div>
						<div class="state-right">
							<img src="../../../assets/oa/state-green.png" alt="" class="state-img">
						</div>
					</div>
				</el-col>
				<el-col :span="6" class="state">
					<div class="state-wrap" @click="stateClick(2)">
						<div class="state-left">
							<div class="state-text">已处理</div>
							<div class="state-number">{{ Num.processed }}</div>
						</div>
						<div class="state-right">
							<img src="../../../assets/oa/state-blue.png" alt="" class="state-img">
						</div>
					</div>
				</el-col>
				<el-col :span="6" class="state">
					<div class="state-wrap" @click="stateClick(3)">
						<div class="state-left">
							<div class="state-text">我收到</div>
							<div class="state-number">{{ Num.myHandle }}</div>
						</div>
						<div class="state-right">
							<img src="../../../assets/oa/state-blue-two.png" alt="" class="state-img">
						</div>
					</div>
				</el-col>
			</el-row>
			<el-form :inline="true" :model="ruleForm" style="position:relative;padding: 20px 0 0 30px;">
				<!-- <div>
                    <el-form-item>
                        <el-input v-model="ruleForm.name" placeholder="请搜索要提交的审批单" clearable>
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <img src="../../../assets/oa/approve-add.png" alt="" style="height: 40px;">
                    </el-form-item>
                </div> -->
			</el-form>
			<div style="margin-top: 20px;">
				<el-collapse class="collapse" style="margin: 0 30px;" v-model="activeName">
					<el-collapse-item v-for="item in List" :key="id" :name="item.approval_process_type">
						<template slot="title">
							<span class="collapse-title">{{ item.approval_process_name }}</span>
							<span class="collapse-title-gray">{{ item.oaManageSetList.length }}</span>
						</template>
						<div class="collapse-wrap">
							<div class="collapse-module" v-for="items in item.oaManageSetList" :key="id"
								@click="collapseClick(items)">
								<img src="../../../assets/oa/collapse-img.png" alt="" class="collapse-img">
								<span class="collapse-text">{{ items.approval_process_name }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>
		</div>
		<approveCenter v-if="approveShow" :stateText="stateText" @closeBack="closeBack()"></approveCenter>
		<expenseReimburse v-if="expenseShow" :collapseId="collapseId" @closeBackTwo="closeBackTwo()"></expenseReimburse>
	</div>
</template>

<script>
	// import { baseRequest } from '@/api/system'
	import approveCenter from '../approve/approveCenter.vue'
	import expenseReimburse from '../approve/expenseReimburse.vue'
	export default {
		components: {
			approveCenter,
			expenseReimburse
		},
		data() {
			return {
				ruleForm: {
					name: '',
				},
				collapseId: '',
				List: [],
				Num: [],
				activeName: [],
				stateText: '',
				approveShow: false,
				expenseShow: false,
			}
		},
		mounted() {
			this.Find()
			this.getTitle()
		},
		methods: {
			collapseClick(e) {
				this.collapseId = e.id;
				this.expenseShow = true
			},
			stateClick(row) {
				console.log(row);
				this.stateText = row
				this.approveShow = true
			},
			closeBack() {
				this.approveShow = false
			},
			closeBackTwo() {
				this.expenseShow = false
			},
			handleChange(val) {
				console.log(val);
			},
			async getTitle() {
				var num = this.$globals.user.staff_id;
				var data = await this.$globals.AxiosGet('OaManageApproval/getNum?info=' + num);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data;
					if (code === '200') {
						this.Num = data.data;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			async Find() {
				var data = await this.$globals.AxiosGet('OaManageSet/findOaApproval');
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data;
					if (code === '200') {
						this.List = data.data;
						data.data.forEach((item) => {
							this.activeName.push(item.approval_process_type)
						})
						console.log(this.activeName)
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			clickBtn(type, item) {
				let that = this;
				const TYPE_METHODS = {
					[""]() {},
				};
				TYPE_METHODS[type]();
			},
		}
	}
</script>

<style>
	.state {
		padding: 0 8px;
	}

	.collapse {
		border-top: 1px solid transparent;
	}

	.el-collapse-item__wrap {
		border-bottom: 1px solid transparent;
		border-top: 1px solid #EBEEF5;
	}
	
</style>
<style scoped>
	.collapse-title {
		font-size: 15px;
		font-weight: 600;
	}

	.collapse-title-gray {
		margin: 0 6px;
		color: #C5C5C7;
		font-size: 15px;

	}

	.collapse-wrap {
		display: flex;
		padding-top: 10px;
	}

	.collapse-module {
		width: 12.5%;
		display: flex;
		align-items: center;
	}

	.collapse-img {
		width: 35px;
		height: 35px;
	}

	.collapse-text {
		font-size: 14px;
		margin: 0 5px;
	}

	.state-wrap {
		display: flex;
		justify-content: space-between;
		height: 70px;
		border-radius: 5px;
		background: #F8F8FA;
		padding: 0 20px;
	}

	.state-left {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.state-text {
		font-size: 14px;
	}

	.state-number {
		font-size: 24px;
		font-weight: 600;
	}

	.state-right {
		display: flex;
		align-items: center;
	}

	.state-img {
		width: 40px;
		height: 40px;
	}

	.dashboard-text {
		font-size: 20px;
		margin: 36px 0 10px 40px;
		font-weight: 600;
	}

	.dashboard-content {
		background: #fff;
		font-size: 16px;
		border: 1px solid transparent;
	}

	.dashboard-button {
		width: 85px;
		background: #006E4B;
		color: #FFFFFF;
		border: 1px solid #006E4B;
	}

	.dashboard-buttonWhite {
		width: 85px;
		color: #006E4B;
		border: 1px solid #006E4B;
	}
</style>



// WEBPACK FOOTER //
// approve.vue?04ef1467